// import { useState, useEffect, useRef } from 'react';
// import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
// // import { getProducts, getPublicAllCategories, getPublicBrands } from '../lib/api';
// import { getPublicProducts, getPublicAllCategories, getPublicBrands } from '../lib/api';

// import ProductGrid from '../components/shop/ProductGrid';

// /* ── Skeleton ─────────────────────────────────────────── */
// function SkeletonGrid() {
//   return (
//     <div className="shop-grid">
//       {Array.from({ length: 12 }).map((_, i) => (
//         <div key={i} className="skeleton-card animate-pulse">
//           <div className="skeleton-img" />
//           <div className="skeleton-line w55" />
//           <div className="skeleton-line w38" />
//         </div>
//       ))}
//     </div>
//   );
// }

// /* ── Custom Dropdown ──────────────────────────────────── */
// function FilterDropdown({ label, value, options, onChange, icon }) {
//   const [open, setOpen] = useState(false);
//   const ref = useRef();

//   useEffect(() => {
//     const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);

//   const selectedLabel = options.find(o => o.value === value)?.label || label;
//   const isActive = value !== 'all' && value !== '';

//   return (
//     <div className={`filter-dropdown ${open ? 'open' : ''}`} ref={ref}>
//       <button
//         className={`filter-btn ${isActive ? 'active' : ''}`}
//         onClick={() => setOpen(v => !v)}
//       >
//         {icon && <span className="filter-icon">{icon}</span>}
//         <span>{selectedLabel}</span>
//         <svg className={`chevron ${open ? 'rotated' : ''}`} width="12" height="12" viewBox="0 0 12 12" fill="none">
//           <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//         </svg>
//       </button>
//       {open && (
//         <div className="dropdown-menu">
//           {options.map(opt => (
//             <div
//               key={opt.value}
//               className={`dropdown-item ${value === opt.value ? 'selected' : ''}`}
//               onClick={() => { onChange(opt.value); setOpen(false); }}
//             >
//               {opt.label}
//               {value === opt.value && (
//                 <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//                   <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//                 </svg>
//               )}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ── Sort Dropdown ────────────────────────────────────── */
// const SORT_OPTIONS = [
//   { value: 'default',    label: 'Featured' },
//   { value: 'price_asc',  label: 'Price: Low to High' },
//   { value: 'price_desc', label: 'Price: High to Low' },
//   { value: 'name_asc',   label: 'Name: A–Z' },
//   { value: 'newest',     label: 'Newest First' },
// ];

// /* ── Main ShopPage ────────────────────────────────────── */
// export default function ShopPage() {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const location  = useLocation();
//   const navigate  = useNavigate();

//   const cat   = searchParams.get('category') || searchParams.get('cat') || 'all';
//   const brand = searchParams.get('brand') || 'all';

//   const [products,   setProducts]   = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [brands,     setBrands]     = useState([]);
//   const [loading,    setLoading]    = useState(true);
//   const [sort,       setSort]       = useState('default');
//   const [search,     setSearch]     = useState('');
//   const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

//   /* ── Fetch products ── */
//   // useEffect(() => {
//   //   setLoading(true);
//   //   getProducts()
//   //     .then(setProducts)
//   //     .catch(() => setProducts([]))
//   //     .finally(() => setLoading(false));
//   // }, [location.search]);
//   useEffect(() => {
//   setLoading(true);
//   getPublicProducts()        // ← changed
//     .then(setProducts)
//     .catch(() => setProducts([]))
//     .finally(() => setLoading(false));
// }, [location.search]);

//   /* ── Fetch filters ── */
//   useEffect(() => {
//     getPublicAllCategories()
//       .then(d => setCategories(Array.isArray(d) ? d : []))
//       .catch(() => setCategories([]));
//     getPublicBrands()
//       .then(d => setBrands(Array.isArray(d) ? d : []))
//       .catch(() => setBrands([]));
//   }, []);

//   /* ── Filter + sort products ── */
//   const filtered = products
//     .filter(p => {
//       const matchCat   = cat   === 'all' || (p.category || '').toLowerCase() === cat.toLowerCase();
//       const matchBrand = brand === 'all' || (p.brand    || '').toLowerCase() === brand.toLowerCase();
//       const q = search.toLowerCase();
//       const matchSearch = !q ||
//         (p.name     || '').toLowerCase().includes(q) ||
//         (p.brand    || '').toLowerCase().includes(q) ||
//         (p.category || '').toLowerCase().includes(q);
//       return matchCat && matchBrand && matchSearch;
//     })
//     .sort((a, b) => {
//       if (sort === 'price_asc')  return Number(a.price) - Number(b.price);
//       if (sort === 'price_desc') return Number(b.price) - Number(a.price);
//       if (sort === 'name_asc')   return (a.name || '').localeCompare(b.name || '');
//       if (sort === 'newest')     return (b.id || 0) - (a.id || 0);
//       return 0;
//     });

//   /* ── Helpers ── */
//   const catOptions = [
//     { value: 'all', label: 'All Categories' },
//     ...categories.map(c => ({ value: c.name, label: c.name })),
//   ];

//   const brandOptions = [
//     { value: 'all', label: 'All Brands' },
//     ...brands.map(b => ({ value: b.name, label: b.name })),
//   ];

//   function setCategory(val) {
//     const params = new URLSearchParams(searchParams);
//     if (val === 'all') params.delete('category'); else params.set('category', val);
//     params.delete('brand');
//     setSearchParams(params);
//   }

//   function setBrand(val) {
//     const params = new URLSearchParams(searchParams);
//     if (val === 'all') params.delete('brand'); else params.set('brand', val);
//     params.delete('category');
//     setSearchParams(params);
//   }

//   function clearAll() {
//     setSearchParams({});
//     setSearch('');
//     setSort('default');
//   }

//   const hasFilters = cat !== 'all' || brand !== 'all' || search;

//   const pageTitle = brand !== 'all' ? brand : cat !== 'all' ? cat : 'The Collection';

//   return (
//     <>
//       {/* ── Inline styles ── */}
//       <style>{`
//         .shop-page {
//           min-height: 100vh;
//           background: #faf9f7;
//           padding-top: 64px;
//         }

//         /* ── Hero Bar ── */
//         .shop-hero {
//           background: var(--dark, #1a1a1a);
//           padding: 48px 40px 40px;
//           position: relative;
//           overflow: hidden;
//         }
//         .shop-hero::before {
//           content: '';
//           position: absolute;
//           inset: 0;
//           background: repeating-linear-gradient(
//             90deg,
//             transparent,
//             transparent 80px,
//             rgba(255,255,255,0.015) 80px,
//             rgba(255,255,255,0.015) 81px
//           );
//           pointer-events: none;
//         }
//         .shop-hero-inner {
//           max-width: 100%;
//           margin: 0 auto;
//           display: flex;
//           align-items: flex-end;
//           justify-content: space-between;
//           gap: 24px;
//           flex-wrap: wrap;
//         }
//         .shop-eyebrow {
//           font-size: 10px;
//           letter-spacing: 0.28em;
//           text-transform: uppercase;
//           color: var(--gold, #c9a84c);
//           font-weight: 600;
//           margin-bottom: 10px;
//         }
//         .shop-title {
//           font-family: var(--font-display, serif);
//           font-size: clamp(28px, 4vw, 52px);
//           font-weight: 300;
//           color: #fff;
//           letter-spacing: -0.01em;
//           margin: 0;
//           line-height: 1.1;
//         }
//         .shop-count {
//           font-size: 12px;
//           color: rgba(255,255,255,0.35);
//           margin-top: 10px;
//           letter-spacing: 0.05em;
//         }
//         .shop-search-wrap {
//           flex-shrink: 0;
//         }
//         .shop-search {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           background: rgba(255,255,255,0.07);
//            border: 1px solid rgba(255,255,255,0.45);
//           padding: 10px 16px;
//           min-width: 260px;
//           transition: border-color 0.2s;
//         }
//         .shop-search:focus-within {
//           border-color: var(--gold, #c9a84c);
//         }
//         .shop-search input {
//           background: none;
//           border: none;
//           outline: none;
//           color: #fff;
//           font-size: 12px;
//           font-family: var(--font-body, sans-serif);
//           letter-spacing: 0.05em;
//           width: 100%;
//         }
//         .shop-search input::placeholder { color: rgba(255,255,255,0.3); }
//         .shop-search svg { flex-shrink: 0; color: rgba(255,255,255,0.35); }

//         /* ── Filter Bar ── */
//         /* ── Filter Bar ── */
// .shop-filter-bar {
//   background: #fff;
//   border-bottom: 1px solid #ece8e1;
//   position: sticky;
//   top: 64px;
//   z-index: 50;
//   box-shadow: 0 2px 12px rgba(0,0,0,0.04);
//   overflow: visible; /* ✅ add this */
// }

// .shop-filter-inner {
//   max-width: 1440px;
//   margin: 0 auto;
//   padding: 0 40px;
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   height: 56px;
//   overflow: visible; /* ✅ change from overflow-x: auto to this */
//   scrollbar-width: none;
// }

// .dropdown-menu {
//   position: absolute;
//   top: calc(100% + 6px);
//   left: 0;
//   background: #fff;
//   border: 1px solid #ece8e1;
//   min-width: 200px;
//   max-height: 320px;
//   overflow-y: auto;
//   z-index: 99999; /* ✅ very high */
//   box-shadow: 0 8px 32px rgba(0,0,0,0.1);
// }
//         .shop-filter-inner::-webkit-scrollbar { display: none; }

//         .filter-divider {
//           width: 1px;
//           height: 20px;
//           background: #ece8e1;
//           flex-shrink: 0;
//           margin: 0 4px;
//         }
//         .filter-spacer { flex: 1; }

//         .sort-label {
//           font-size: 10px;
//           letter-spacing: 0.12em;
//           text-transform: uppercase;
//           color: var(--grey-mid, #999);
//           white-space: nowrap;
//           flex-shrink: 0;
//         }

//         .clear-btn {
//           display: flex;
//           align-items: center;
//           gap: 5px;
//           font-size: 10px;
//           letter-spacing: 0.1em;
//           text-transform: uppercase;
//           color: #dc2626;
//           background: #fef2f2;
//           border: 1px solid #fecaca;
//           padding: 5px 12px;
//           cursor: pointer;
//           font-family: var(--font-body, sans-serif);
//           font-weight: 600;
//           white-space: nowrap;
//           flex-shrink: 0;
//           transition: background 0.2s;
//         }
//         .clear-btn:hover { background: #fee2e2; }

//         /* ── Filter Dropdown ── */
//         .filter-dropdown { position: relative; flex-shrink: 0; }
//         .filter-btn {
//           display: flex;
//           align-items: center;
//           gap: 7px;
//           padding: 7px 14px;
//           background: none;
//           border: 1px solid #ece8e1;
//           cursor: pointer;
//           font-size: 11px;
//           font-family: var(--font-body, sans-serif);
//           letter-spacing: 0.08em;
//           color: var(--dark, #1a1a1a);
//           white-space: nowrap;
//           transition: all 0.2s;
//         }
//         .filter-btn:hover { border-color: var(--dark, #1a1a1a); }
//         .filter-btn.active {
//           background: var(--dark, #1a1a1a);
//           border-color: var(--dark, #1a1a1a);
//           color: #fff;
//         }
//         .filter-icon { font-size: 13px; }
//         .chevron { transition: transform 0.2s; flex-shrink: 0; }
//         .chevron.rotated { transform: rotate(180deg); }

//         .dropdown-menu {
//           position: absolute;
//           top: calc(100% + 6px);
//           left: 0;
//           background: #fff;
//           border: 1px solid #ece8e1;
//           min-width: 200px;
//           max-height: 320px;
//           overflow-y: auto;
//           z-index: 200;
//           box-shadow: 0 8px 32px rgba(0,0,0,0.1);
//         }
//         .dropdown-item {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 10px 16px;
//           font-size: 12px;
//           font-family: var(--font-body, sans-serif);
//           color: var(--dark, #1a1a1a);
//           cursor: pointer;
//           letter-spacing: 0.04em;
//           transition: background 0.15s;
//           border-bottom: 1px solid #f5f3ef;
//         }
//         .dropdown-item:last-child { border-bottom: none; }
//         .dropdown-item:hover { background: #faf9f7; }
//         .dropdown-item.selected {
//           background: #faf9f7;
//           font-weight: 600;
//           color: var(--gold, #c9a84c);
//         }

//         /* ── Active Filters Chips ── */
//         .active-filters {
//           max-width: 1440px;
//           margin: 0 auto;
//           padding: 14px 40px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           flex-wrap: wrap;
//         }
//         .filter-chip {
//           display: flex;
//           align-items: center;
//           gap: 6px;
//           padding: 5px 12px;
//           background: var(--dark, #1a1a1a);
//           color: #fff;
//           font-size: 10px;
//           letter-spacing: 0.1em;
//           text-transform: uppercase;
//           font-weight: 600;
//           font-family: var(--font-body, sans-serif);
//         }
//         .chip-remove {
//           background: none;
//           border: none;
//           cursor: pointer;
//           color: rgba(255,255,255,0.5);
//           padding: 0;
//           display: flex;
//           align-items: center;
//           font-size: 14px;
//           line-height: 1;
//           transition: color 0.2s;
//         }
//         .chip-remove:hover { color: #fff; }

//         /* ── Content ── */
//         .shop-content {
//           max-width: 100%;
//           margin: 0 auto;
//           padding: 32px 40px 80px;
//         }

//         /* ── Grid ── */
//         .shop-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
//           gap: 20px;
//           row-gap: 48px;
//         }

//         /* ── Skeleton ── */
//         .skeleton-card { display: flex; flex-direction: column; align-items: center; }
//         .skeleton-img {
//           width: 100%;
//           aspect-ratio: 3/4;
//           background: #e8e4de;
//           animation: shimmer 1.5s infinite;
//         }
//         .skeleton-line {
//           height: 10px;
//           background: #e8e4de;
//           margin-top: 12px;
//           border-radius: 2px;
//           animation: shimmer 1.5s infinite;
//         }
//         .w55 { width: 55%; }
//         .w38 { width: 38%; }
//         @keyframes shimmer {
//           0%   { opacity: 1; }
//           50%  { opacity: 0.5; }
//           100% { opacity: 1; }
//         }

//         /* ── Empty State ── */
//         .shop-empty {
//           text-align: center;
//           padding: 80px 20px;
//         }
//         .shop-empty-icon {
//           font-size: 48px;
//           margin-bottom: 16px;
//           opacity: 0.3;
//         }
//         .shop-empty h3 {
//           font-family: var(--font-display, serif);
//           font-size: 24px;
//           font-weight: 300;
//           color: var(--dark, #1a1a1a);
//           margin-bottom: 8px;
//         }
//         .shop-empty p {
//           font-size: 13px;
//           color: var(--grey-mid, #999);
//           margin-bottom: 24px;
//         }
//         .shop-empty-btn {
//           padding: 10px 28px;
//           background: var(--dark, #1a1a1a);
//           color: #fff;
//           border: none;
//           cursor: pointer;
//           font-size: 11px;
//           letter-spacing: 0.15em;
//           text-transform: uppercase;
//           font-weight: 600;
//           font-family: var(--font-body, sans-serif);
//           transition: background 0.2s;
//         }
//         .shop-empty-btn:hover { background: var(--gold, #c9a84c); }

//         /* ── Mobile Filter Toggle ── */
//         .mobile-filter-toggle {
//           display: none;
//           align-items: center;
//           gap: 8px;
//           padding: 7px 14px;
//           background: none;
//           border: 1px solid #ece8e1;
//           cursor: pointer;
//           font-size: 11px;
//           font-family: var(--font-body, sans-serif);
//           letter-spacing: 0.08em;
//           color: var(--dark, #1a1a1a);
//           white-space: nowrap;
//           flex-shrink: 0;
//         }

//         /* ── Mobile Drawer ── */
//         .mobile-filter-drawer {
//           display: none;
//           position: fixed;
//           inset: 0;
//           z-index: 500;
//         }
//         .mobile-filter-drawer.open { display: block; }
//         .drawer-backdrop {
//           position: absolute;
//           inset: 0;
//           background: rgba(0,0,0,0.5);
//         }
//         .drawer-panel {
//           position: absolute;
//           bottom: 0;
//           left: 0;
//           right: 0;
//           background: #fff;
//           border-radius: 16px 16px 0 0;
//           padding: 24px 24px 48px;
//           max-height: 85vh;
//           overflow-y: auto;
//         }
//         .drawer-handle {
//           width: 40px;
//           height: 4px;
//           background: #ddd;
//           border-radius: 2px;
//           margin: 0 auto 24px;
//         }
//         .drawer-title {
//           font-family: var(--font-display, serif);
//           font-size: 20px;
//           font-weight: 300;
//           color: var(--dark, #1a1a1a);
//           margin-bottom: 24px;
//         }
//         .drawer-section { margin-bottom: 24px; }
//         .drawer-section-label {
//           font-size: 10px;
//           letter-spacing: 0.18em;
//           text-transform: uppercase;
//           color: var(--grey-mid, #999);
//           font-weight: 600;
//           margin-bottom: 10px;
//           display: block;
//         }
//         .drawer-options {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 8px;
//         }
//         .drawer-option {
//           padding: 7px 14px;
//           border: 1px solid #ece8e1;
//           font-size: 12px;
//           font-family: var(--font-body, sans-serif);
//           cursor: pointer;
//           color: var(--dark, #1a1a1a);
//           transition: all 0.15s;
//         }
//         .drawer-option.active {
//           background: var(--dark, #1a1a1a);
//           border-color: var(--dark, #1a1a1a);
//           color: #fff;
//         }
//         .drawer-apply {
//           width: 100%;
//           padding: 14px;
//           background: var(--dark, #1a1a1a);
//           color: #fff;
//           border: none;
//           cursor: pointer;
//           font-size: 12px;
//           letter-spacing: 0.15em;
//           text-transform: uppercase;
//           font-weight: 700;
//           font-family: var(--font-body, sans-serif);
//           margin-top: 8px;
//           transition: background 0.2s;
//         }
//         .drawer-apply:hover { background: var(--gold, #c9a84c); }

//         /* ── Responsive ── */
//        @media (max-width: 768px) {
//   .shop-hero { padding: 36px 20px 28px; }
//   .shop-search-wrap { width: 100%; }
//   .shop-search { min-width: unset; width: 100%; }
//   .shop-filter-inner { padding: 0 16px; }
//   .filter-dropdown { display: none; }
//   .filter-divider { display: none; }
//   .sort-label { display: none; }
//   .mobile-filter-toggle { display: flex; }
//   .shop-content { padding: 24px 16px 60px; }
//   .active-filters { padding: 10px 16px; }
//   .shop-grid {
//     grid-template-columns: repeat(2, 1fr); /* ✅ already correct */
//     gap: 12px;
//     row-gap: 32px;
//   }
// }

//       `}</style>

//       <div className="shop-page">

//         {/* ── Hero Bar ── */}
//         <div className="shop-hero">
//           <div className="shop-hero-inner">
//             <div>
//               <div className="shop-eyebrow">Aurora Luxury · The Collection</div>
//               <h1 className="shop-title">{pageTitle}</h1>
//               {!loading && (
//                 <div className="shop-count">
//                   {filtered.length} piece{filtered.length !== 1 ? 's' : ''} available
//                 </div>
//               )}
//             </div>
//             <div className="shop-search-wrap">
//               <div className="shop-search">
//                 <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
//                   <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
//                 </svg>
//                 <input
//                   value={search}
//                   onChange={e => setSearch(e.target.value)}
//                   placeholder="Search pieces…"
//                 />
//                 {search && (
//                   <button
//                     onClick={() => setSearch('')}
//                     style={{ background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,0.4)', fontSize:16, lineHeight:1, padding:0 }}
//                   >×</button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ── Filter Bar ── */}
//         <div className="shop-filter-bar">
//           <div className="shop-filter-inner">

//             {/* Mobile toggle */}
//             <button className="mobile-filter-toggle" onClick={() => setMobileFiltersOpen(true)}>
//               <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
//                 <line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="20" y2="12"/><line x1="12" y1="18" x2="20" y2="18"/>
//               </svg>
//               Filters
//               {hasFilters && <span style={{ width:6, height:6, borderRadius:'50%', background:'var(--gold,#c9a84c)', display:'inline-block' }} />}
//             </button>

//             {/* Desktop filters */}
//             <FilterDropdown
//               label="All Categories"
//               value={cat}
//               options={catOptions}
//               onChange={setCategory}
//             />

//             <div className="filter-divider" />

//             <FilterDropdown
//               label="All Brands"
//               value={brand}
//               options={brandOptions}
//               onChange={setBrand}
//             />

//             {hasFilters && (
//               <>
//                 <div className="filter-divider" />
//                 <button className="clear-btn" onClick={clearAll}>
//                   × Clear
//                 </button>
//               </>
//             )}

//             <div className="filter-spacer" />

//             <span className="sort-label">Sort:</span>
//             <FilterDropdown
//               label="Featured"
//               value={sort}
//               options={SORT_OPTIONS}
//               onChange={setSort}
//             />
//           </div>
//         </div>

//         {/* ── Active Filter Chips ── */}
//         {hasFilters && (
//           <div className="active-filters">
//             {cat !== 'all' && (
//               <div className="filter-chip">
//                 {cat}
//                 <button className="chip-remove" onClick={() => setCategory('all')}>×</button>
//               </div>
//             )}
//             {brand !== 'all' && (
//               <div className="filter-chip">
//                 {brand}
//                 <button className="chip-remove" onClick={() => setBrand('all')}>×</button>
//               </div>
//             )}
//             {search && (
//               <div className="filter-chip">
//                 "{search}"
//                 <button className="chip-remove" onClick={() => setSearch('')}>×</button>
//               </div>
//             )}
//           </div>
//         )}

//         {/* ── Content ── */}
//         <div className="shop-content">
//           {loading ? (
//             <SkeletonGrid />
//           ) : filtered.length === 0 ? (
//             <div className="shop-empty">
//               <div className="shop-empty-icon">🔍</div>
//               <h3>No pieces found</h3>
//               <p>Try adjusting your filters or search term.</p>
//               <button className="shop-empty-btn" onClick={clearAll}>Clear All Filters</button>
//             </div>
//           ) : (
//             <ProductGrid products={filtered} />
//           )}
//         </div>

//         {/* ── Mobile Filter Drawer ── */}
//         <div className={`mobile-filter-drawer ${mobileFiltersOpen ? 'open' : ''}`}>
//           <div className="drawer-backdrop" onClick={() => setMobileFiltersOpen(false)} />
//           <div className="drawer-panel">
//             <div className="drawer-handle" />
//             <div className="drawer-title">Filter & Sort</div>

//             {/* Categories */}
//             <div className="drawer-section">
//               <span className="drawer-section-label">Category</span>
//               <div className="drawer-options">
//                 {catOptions.map(opt => (
//                   <div
//                     key={opt.value}
//                     className={`drawer-option ${cat === opt.value ? 'active' : ''}`}
//                     onClick={() => setCategory(opt.value)}
//                   >
//                     {opt.label}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Brands */}
//             <div className="drawer-section">
//               <span className="drawer-section-label">Brand</span>
//               <div className="drawer-options">
//                 {brandOptions.map(opt => (
//                   <div
//                     key={opt.value}
//                     className={`drawer-option ${brand === opt.value ? 'active' : ''}`}
//                     onClick={() => setBrand(opt.value)}
//                   >
//                     {opt.label}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Sort */}
//             <div className="drawer-section">
//               <span className="drawer-section-label">Sort By</span>
//               <div className="drawer-options">
//                 {SORT_OPTIONS.map(opt => (
//                   <div
//                     key={opt.value}
//                     className={`drawer-option ${sort === opt.value ? 'active' : ''}`}
//                     onClick={() => setSort(opt.value)}
//                   >
//                     {opt.label}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <button className="drawer-apply" onClick={() => setMobileFiltersOpen(false)}>
//               View {filtered.length} Result{filtered.length !== 1 ? 's' : ''}
//             </button>
//           </div>
//         </div>

//       </div>
//     </>
//   );
// }

import { useState, useEffect, useRef } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { getPublicProducts, getPublicAllCategories, getPublicBrands } from '../lib/api';
import ProductGrid from '../components/shop/ProductGrid';

/* ─────────────────────────────────────────────
   SkeletonGrid
───────────────────────────────────────────── */
function SkeletonGrid() {
  return (
    <div className="shop-grid">
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} className="skeleton-card animate-pulse">
          <div className="skeleton-img" />
          <div className="skeleton-line w55" />
          <div className="skeleton-line w38" />
        </div>
      ))}
    </div>
  );
}

/* ─────────────────────────────────────────────
   FilterDropdown
───────────────────────────────────────────── */
function FilterDropdown({ label, value, options, onChange, icon }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selectedLabel = options.find(o => o.value === value)?.label || label;
  const isActive      = value !== 'all' && value !== '';

  return (
    <div className={`filter-dropdown ${open ? 'open' : ''}`} ref={ref}>
      <button
        className={`filter-btn ${isActive ? 'active' : ''}`}
        onClick={() => setOpen(v => !v)}
      >
        {icon && <span className="filter-icon">{icon}</span>}
        <span>{selectedLabel}</span>
        <svg
          className={`chevron ${open ? 'rotated' : ''}`}
          width="12" height="12" viewBox="0 0 12 12" fill="none"
        >
          <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      {open && (
        <div className="dropdown-menu">
          {options.map(opt => (
            <div
              key={opt.value}
              className={`dropdown-item ${value === opt.value ? 'selected' : ''}`}
              onClick={() => { onChange(opt.value); setOpen(false); }}
            >
              {opt.label}
              {value === opt.value && (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   Sort options
───────────────────────────────────────────── */
const SORT_OPTIONS = [
  { value: 'default',    label: 'Featured'           },
  { value: 'price_asc',  label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
  { value: 'name_asc',   label: 'Name: A–Z'          },
  { value: 'newest',     label: 'Newest First'        },
];

/* ─────────────────────────────────────────────
   ShopPage
───────────────────────────────────────────── */
export default function ShopPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const cat   = searchParams.get('category') || searchParams.get('cat') || 'all';
  const brand = searchParams.get('brand') || 'all';

  const [products,          setProducts]          = useState([]);
  const [categories,        setCategories]        = useState([]);
  const [brands,            setBrands]            = useState([]);
  const [loading,           setLoading]           = useState(true);
  const [sort,              setSort]              = useState('default');
  const [search,            setSearch]            = useState('');
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

  /* ── Fetch products ── */
  useEffect(() => {
    setLoading(true);
    getPublicProducts()
      .then(setProducts)
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [location.search]);

  /* ── Fetch filters ── */
  useEffect(() => {
    getPublicAllCategories()
      .then(d => setCategories(Array.isArray(d) ? d : []))
      .catch(() => setCategories([]));
    getPublicBrands()
      .then(d => setBrands(Array.isArray(d) ? d : []))
      .catch(() => setBrands([]));
  }, []);

  /* ── Filter + sort ── */
  const filtered = products
    .filter(p => {
      const matchCat    = cat   === 'all' || (p.category || '').toLowerCase() === cat.toLowerCase();
      const matchBrand  = brand === 'all' || (p.brand    || '').toLowerCase() === brand.toLowerCase();
      const q           = search.toLowerCase();
      const matchSearch = !q ||
        (p.name     || '').toLowerCase().includes(q) ||
        (p.brand    || '').toLowerCase().includes(q) ||
        (p.category || '').toLowerCase().includes(q);
      return matchCat && matchBrand && matchSearch;
    })
    .sort((a, b) => {
      if (sort === 'price_asc')  return Number(a.price) - Number(b.price);
      if (sort === 'price_desc') return Number(b.price) - Number(a.price);
      if (sort === 'name_asc')   return (a.name || '').localeCompare(b.name || '');
      if (sort === 'newest')     return (b.id || 0) - (a.id || 0);
      return 0;
    });

  /* ── Helpers ── */
  const catOptions = [
    { value: 'all', label: 'All Categories' },
    ...categories.map(c => ({ value: c.name, label: c.name })),
  ];

  const brandOptions = [
    { value: 'all', label: 'All Brands' },
    ...brands.map(b => ({ value: b.name, label: b.name })),
  ];

  function setCategory(val) {
    const params = new URLSearchParams(searchParams);
    if (val === 'all') params.delete('category'); else params.set('category', val);
    params.delete('brand');
    setSearchParams(params);
  }

  function setBrand(val) {
    const params = new URLSearchParams(searchParams);
    if (val === 'all') params.delete('brand'); else params.set('brand', val);
    params.delete('category');
    setSearchParams(params);
  }

  function clearAll() {
    setSearchParams({});
    setSearch('');
    setSort('default');
  }

  const hasFilters = cat !== 'all' || brand !== 'all' || search;
  const pageTitle  = brand !== 'all' ? brand : cat !== 'all' ? cat : 'The Collection';

  return (
    <div className="shop-page">

      {/* ── Hero Bar ── */}
      <div className="shop-hero">
        <div className="shop-hero-inner">
          <div>
            <div className="shop-eyebrow">Aurora Luxury · The Collection</div>
            <h1 className="shop-title">{pageTitle}</h1>
            {!loading && (
              <div className="shop-count">
                {filtered.length} piece{filtered.length !== 1 ? 's' : ''} available
              </div>
            )}
          </div>
          <div className="shop-search-wrap">
            <div className="shop-search">
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search pieces…"
              />
              {search && (
                <button
                  onClick={() => setSearch('')}
                  className="bg-transparent border-none cursor-pointer text-white/40 text-[16px] leading-none p-0"
                >
                  ×
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ── Filter Bar ── */}
      <div className="shop-filter-bar">
        <div className="shop-filter-inner">

          {/* Mobile toggle */}
          <button className="mobile-filter-toggle" onClick={() => setMobileFiltersOpen(true)}>
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <line x1="4" y1="6" x2="20" y2="6"/>
              <line x1="8" y1="12" x2="20" y2="12"/>
              <line x1="12" y1="18" x2="20" y2="18"/>
            </svg>
            Filters
            {hasFilters && (
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--gold)] inline-block" />
            )}
          </button>

          {/* Desktop filters */}
          <FilterDropdown label="All Categories" value={cat}   options={catOptions}   onChange={setCategory} />
          <div className="filter-divider" />
          <FilterDropdown label="All Brands"     value={brand} options={brandOptions} onChange={setBrand} />

          {hasFilters && (
            <>
              <div className="filter-divider" />
              <button className="clear-btn" onClick={clearAll}>× Clear</button>
            </>
          )}

          <div className="filter-spacer" />
          <span className="sort-label">Sort:</span>
          <FilterDropdown label="Featured" value={sort} options={SORT_OPTIONS} onChange={setSort} />
        </div>
      </div>

      {/* ── Active Filter Chips ── */}
      {hasFilters && (
        <div className="active-filters">
          {cat !== 'all' && (
            <div className="filter-chip">
              {cat}
              <button className="chip-remove" onClick={() => setCategory('all')}>×</button>
            </div>
          )}
          {brand !== 'all' && (
            <div className="filter-chip">
              {brand}
              <button className="chip-remove" onClick={() => setBrand('all')}>×</button>
            </div>
          )}
          {search && (
            <div className="filter-chip">
              "{search}"
              <button className="chip-remove" onClick={() => setSearch('')}>×</button>
            </div>
          )}
        </div>
      )}

      {/* ── Content ── */}
      <div className="shop-content">
        {loading ? (
          <SkeletonGrid />
        ) : filtered.length === 0 ? (
          <div className="shop-empty">
            <div className="shop-empty-icon">🔍</div>
            <h3>No pieces found</h3>
            <p>Try adjusting your filters or search term.</p>
            <button className="shop-empty-btn" onClick={clearAll}>Clear All Filters</button>
          </div>
        ) : (
          <ProductGrid products={filtered} />
        )}
      </div>

      {/* ── Mobile Filter Drawer ── */}
      <div className={`mobile-filter-drawer ${mobileFiltersOpen ? 'open' : ''}`}>
        <div className="drawer-backdrop" onClick={() => setMobileFiltersOpen(false)} />
        <div className="drawer-panel">
          <div className="drawer-handle" />
          <div className="drawer-title">Filter & Sort</div>

          <div className="drawer-section">
            <span className="drawer-section-label">Category</span>
            <div className="drawer-options">
              {catOptions.map(opt => (
                <div
                  key={opt.value}
                  className={`drawer-option ${cat === opt.value ? 'active' : ''}`}
                  onClick={() => setCategory(opt.value)}
                >
                  {opt.label}
                </div>
              ))}
            </div>
          </div>

          <div className="drawer-section">
            <span className="drawer-section-label">Brand</span>
            <div className="drawer-options">
              {brandOptions.map(opt => (
                <div
                  key={opt.value}
                  className={`drawer-option ${brand === opt.value ? 'active' : ''}`}
                  onClick={() => setBrand(opt.value)}
                >
                  {opt.label}
                </div>
              ))}
            </div>
          </div>

          <div className="drawer-section">
            <span className="drawer-section-label">Sort By</span>
            <div className="drawer-options">
              {SORT_OPTIONS.map(opt => (
                <div
                  key={opt.value}
                  className={`drawer-option ${sort === opt.value ? 'active' : ''}`}
                  onClick={() => setSort(opt.value)}
                >
                  {opt.label}
                </div>
              ))}
            </div>
          </div>

          <button className="drawer-apply" onClick={() => setMobileFiltersOpen(false)}>
            View {filtered.length} Result{filtered.length !== 1 ? 's' : ''}
          </button>
        </div>
      </div>

    </div>
  );
}